import React, {useState} from 'react';
import {
   Modal,
   View,
   Text,
   TouchableOpacity,
   StyleSheet,
   Image,
   Platform,
   Button,
} from 'react-native';
import {
   BUTTON_HOVER_COLOR,
   FONT_FAMILY_BOLD,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   WHITE_TEXT_HOVER_COLOR,
   isWeb,
   primaryColor400,
   primaryColor500,
   primaryColor800,
} from './utils';
import {useDispatch} from 'react-redux';
import {isMobileOnly} from 'react-device-detect';

const NorcatAlert = props => {
   const [showAlert, setShowAlert] = useState(props.show);
   const [title, stTitle] = useState(props.title);
   const [message, setMessage] = useState(props.message);
   const [actionPositive, setActionPositive] = useState(props.actionPositive);
   const [buttonText, setButtonText] = useState(props.buttonText);
   const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';
   const [isHover, setHover] = useState(false);

   return isDesktop ? (
      <View
         style={[
            Platform.OS === 'macos' ? {} : styles.container,
            {opacity: 1},
         ]}>
         <View style={styles.alert}>
            <Image
               source={
                  actionPositive
                     ? require('../assets/alert_right_tick.png')
                     : require('../assets/alert_right_cross.png')
               }
               style={{width: 64, height: 64}}
            />
            <Text style={styles.alertTitle}>{title}</Text>
            <Text style={styles.message}>{message}</Text>

            <TouchableOpacity
               onMouseEnter={() => setHover(true)}
               onMouseLeave={() => setHover(false)}
               onPress={() => {
                  setShowAlert(false);
                  props.onCallBack(actionPositive);
               }}
               style={[
                  styles.button,
                  isHover && {backgroundColor: BUTTON_HOVER_COLOR},
               ]}>
               <Text
                  style={[
                     styles.buttonText,
                     isHover && {color: WHITE_TEXT_HOVER_COLOR},
                  ]}>
                  {buttonText}
               </Text>
            </TouchableOpacity>
         </View>
      </View>
   ) : isWeb ? (
      <Modal
         animationType="true"
         transparent={true}
         visible={showAlert}
         onRequestClose={() => {
            setShowAlert(!showAlert);
         }}>
         <View style={[styles.container, {backgroundColor: 'rgba(0,0,0,0.8)'}]}>
            <View
               style={[
                  styles.alert,
                  {
                     width: 280,
                     minHeight: null,
                     boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
               ]}>
               {props?.tomIcon && (
                  <Image
                     source={
                        actionPositive
                           ? require('../assets/alert_right_tick.png')
                           : require('../assets/alert_right_cross.png')
                     }
                     style={{width: 64, height: 64}}
                  />
               )}
               <Text
                  style={[
                     styles.alertTitle,
                     {
                        marginTop: 0,
                        fontSize: 16,
                        fontWeight: '600',
                        fontFamily: FONT_FAMILY_BOLD,
                     },
                  ]}>
                  {title}
               </Text>
               <Text
                  style={[
                     styles.message,
                     {
                        fontSize: 14,
                        fontWeight: '400',
                        fontFamily: FONT_FAMILY_REGULAR,
                        color: '#000',
                     },
                  ]}>
                  {message}
               </Text>
               <View
                  style={{
                     width: '100%',
                     justifyContent: 'center',
                     alignItems: 'center',
                     //margin: 24,
                  }}>
                  <TouchableOpacity
                     onMouseEnter={() => setHover(true)}
                     onMouseLeave={() => setHover(false)}
                     onPress={() => {
                        setShowAlert(false);
                        props.onCallBack();
                     }}
                     style={{
                        backgroundColor: isHover
                           ? BUTTON_HOVER_COLOR
                           : primaryColor500,
                        borderRadius: 15,
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 32,
                        width: 80,
                     }}>
                     <Text
                        style={[
                           styles.buttonText,
                           isHover && {color: WHITE_TEXT_HOVER_COLOR},
                           {
                              textAlignVertical: 'center',
                              marginBottom: isMobileOnly ? 0 : 1,
                           },
                        ]}>
                        {buttonText}
                     </Text>
                  </TouchableOpacity>
               </View>
            </View>
         </View>
      </Modal>
   ) : (
      <Modal
         animationType="true"
         transparent={true}
         visible={showAlert}
         onRequestClose={() => {
            setShowAlert(!showAlert);
         }}>
         <View style={styles.container}>
            <View style={styles.alert}>
               <Image
                  source={
                     actionPositive
                        ? require('../assets/alert_right_tick.png')
                        : require('../assets/alert_right_cross.png')
                  }
                  style={{width: 64, height: 64}}
               />
               <Text style={styles.alertTitle}>{title}</Text>
               <Text style={styles.message}>{message}</Text>

               <TouchableOpacity
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                  onPress={() => {
                     setShowAlert(false);
                     props.onCallBack(actionPositive);
                  }}
                  style={[
                     styles.button,
                     isHover && {backgroundColor: BUTTON_HOVER_COLOR},
                  ]}>
                  <Text
                     style={[
                        styles.buttonText,
                        isHover && {color: WHITE_TEXT_HOVER_COLOR},
                     ]}>
                     {buttonText}
                  </Text>
               </TouchableOpacity>
            </View>
         </View>
      </Modal>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.9001)',
      borderColor:
         Platform.OS === 'windows' ? 'rgba(158, 150, 150, 0.2)' : null,
      borderWidth: Platform.OS === 'windows' ? 2 : null,
      borderRadius: Platform.OS === 'windows' ? 10 : null,
   },
   alert: {
      backgroundColor: 'white',
      padding: 24,
      borderRadius: 8,
      minWidth: 343,
      minHeight: 311,
      alignItems: 'center',
   },
   alertTitle: {
      fontSize: 24,
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '600',
      color: primaryColor800,
      marginTop: 24,
   },
   message: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      fontWeight: '500',
      color: '#8897AE',
      marginTop: 8,
      marginBottom: 24,
   },
   button: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: primaryColor500,
      height: 50,
      alignItems: 'center',
      justifyContent: 'center',
      margin: 24,
   },
   buttonText: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_MEDIUM,
      fontWeight: '500',
      color: 'white',
   },
});

export default NorcatAlert;
